import { render, staticRenderFns } from "./TopPanel.vue?vue&type=template&id=e8c20d58&scoped=true"
import script from "./TopPanel.vue?vue&type=script&lang=js"
export * from "./TopPanel.vue?vue&type=script&lang=js"
import style0 from "./TopPanel.vue?vue&type=style&index=0&id=e8c20d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c20d58",
  null
  
)

export default component.exports